import locale from "@/helpers/locale";
import { MessageBox } from "element-ui";
export const createSeatItem = () => {
  return {
    deleteClass: false,// 是否删除（好像用不上）
    link: "",// 情侣座关联的格子
    seatStatus: "general",// 座位类型
    text: "",// 文本（列）
    whiteBg: false,// 是否是白色的格子
    translate: 0,// 偏移
    rowString: "",// 文本（行）
    sid: "",
  };
};

export const createSeats = (row = 1, col = 1, rowOrder, colOrder) => {
  let seats = [];
  let rowNum = row + 2;
  let colNum = col + 2;
  let colTitle = [];

  for (let i = 0; i < rowNum; i++) {
    let arr = [];
    let letter = String.fromCharCode(i + 65 - 1);

    if (i == 0 || i == rowNum - 1) {
      colTitle.push("");
    } else {
      colTitle.push(letter);
    }

    for (let j = 0; j < colNum; j++) {
      let seatObj = createSeatItem();

      if (i == 0 || j == 0 || i == rowNum - 1 || j == colNum - 1) {
        seatObj.whiteBg = true;
      }

      if (j > 0 && j < colNum - 1 && i > 0 && i < rowNum - 1) {
        seatObj.text = j;
        seatObj.rowString = letter;
        seatObj.sid = seatObj.rowString + seatObj.text;
      } else {
        seatObj.sid = j === 0 ? letter + -1 : letter + j;
        seatObj.seatStatus = null;
      }
      // seatObj.sid = seatObj.rowString + seatObj.text;

      arr.push(seatObj);
    }

    if (colOrder != "order") {
      arr.reverse();
    }

    seats.push(arr);
  }

  if (rowOrder != "order") {
    colTitle.reverse();
    seats.reverse();
  }

  return { seats, colTitle };
};

export const createSeatController = () => {
  return {
    line: "num",
    column: "eng",
    lineOrder: "order",
    columnOrder: "order",
  };
};

export const createSeatSetting = () => {
  return [
    {
      decorationName: locale("theatre.seat.general"),
      seatStatus: "general",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    },
    {
      decorationName: locale("theatre.seat.vip"),
      seatStatus: "vip",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    },
    {
      decorationName: locale("theatre.seat.special"),
      seatStatus: "special",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    },
    {
      decorationName: locale("theatre.seat.stopsale"),
      seatStatus: "close",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    },
    {
      decorationName: locale("theatre.seat.windowSeat"),
      seatStatus: "posCounter",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    },
    {
      decorationName: locale("rules.loversSeat"),
      seatStatus: "lovers",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    },
    {
      decorationName: locale("rules.wheelchair"),
      seatStatus: "wheelchair",
      warningMsg: [
        {
          deviceType: "",
          message: ""
        }
      ],
    }
  ];
};
export const addCol = (originalSeats, order) => {
  let newSeats = JSON.parse(JSON.stringify(originalSeats));
  let rowLength = newSeats.length;
  let oldColLength = originalSeats[0].length;

  newSeats.map((item, rowIndex) => {
    let pushObj = { ...item[oldColLength - 2], link: "" };
    const rowString = pushObj.sid.replace(/[0-9]/g, "");
    let sidNum = parseInt(pushObj.sid.replace(/[^0-9]/g, ""));

    if (rowIndex == 0 || rowIndex == rowLength - 1) {
      pushObj.seatStatus = null;
    } else {
      pushObj.seatStatus = "general";
    }

    if (order == "order") {
      sidNum += 1;
      pushObj.sid = rowString + sidNum;

      if (pushObj.text) {
        pushObj.text = sidNum;
      }

      item[item.length - 1].sid = rowString + (sidNum + 1);
    } else {
      pushObj.sid = rowString + sidNum;

      if (pushObj.text) {
        pushObj.text = sidNum;
      }

      for (let i = 0; i < item.length - 1; i++) {
        let thisNum = parseInt(item[i].sid.replace(/[^0-9]/g, ""));

        item[i].sid = rowString + (thisNum + 1);

        if (item[i].text) {
          item[i].text = thisNum + 1;
        }
      }
    }

    item.splice(oldColLength - 1, 0, pushObj);
  });

  return newSeats;
};

export const setSeatNumber = (seats, axis, targetNum, order) => {
  let [row, col] = axis;
  let newSeats = JSON.parse(JSON.stringify(seats));
  let inputNum = targetNum == "" ? 0 : parseInt(targetNum);
  let curRow = [];
  // console.log(newSeats);
  newSeats[row].forEach((item, idx) => {
    curRow.push(item.sid);
  });
  if (curRow.indexOf(newSeats[row][col].sid.replace(/[^A-Z]/g, "") + inputNum) < 0) {
    if(order === "order" && newSeats[row][0].text !== -1) {
      newSeats[row][0].text = -1;
      newSeats[row][0].sid = newSeats[row][col].sid.replace(/[^A-Z]/g, "") + "-1";
    }
    newSeats[row][col].text = inputNum;
    newSeats[row][col].sid = newSeats[row][col].sid.replace(/[^A-Z]/g, "") + inputNum;
  } else {
    MessageBox.alert(locale("theatre.SeatNumberRepeat"));
  }
  // if (order === "order" && differNum >= -1 || (order !== "order" && inputNum > (newSeats[row].length - 4 - col))) {
  //   newSeats[row].map((item, itemIndex) => {
  //     item.link = "";

  //     let itemText = "";
  //     let rowString = item.sid.replace(/[^A-Z]/g, "");

  //     if (order == "order") {
  //       itemText = itemIndex >= col ? (itemIndex + differNum) : itemIndex - 1;
  //     } else {
  //       itemText = itemIndex <= col ? (inputNum + col - itemIndex) : (newSeats[row].length - 1 - itemIndex);
  //     }
  //     if (item.text !== "") {
  //       item.text = itemText;
  //     }
  //     item.sid = rowString + itemText;
  //   });
  // }

  newSeats[axis[0]].map((item, itemIndex) => {
    if (item.seatStatus == "lovers") {
      if (item.link == "" && newSeats[axis[0]][itemIndex + 1].link == "" && newSeats[axis[0]][itemIndex + 1].seatStatus == "lovers") {
        item.link = newSeats[axis[0]][itemIndex + 1].text;
        newSeats[axis[0]][itemIndex + 1].link = item.text;
      }
    }
  });

  return newSeats;
};

export const translateSeats = (seats, axis, orientation) => {
  let [row, col] = axis;
  let newSeats = JSON.parse(JSON.stringify(seats));
  let index = col;
  let translateSeat = [];
  let translateUnit = 0.5;

  if (newSeats[row][col].seatStatus == "lovers") {
    for (let i = 1; i < newSeats[row].length; i++) {
      if (newSeats[row][i].text == newSeats[row][col].link) {
        if (orientation == "left") {
          index = index > i ? index : i;
        } else {
          index = index > i ? i : index;
        }
        break;
      }
    }
  }

  if (orientation == "left") {
    for (let i = 1; i <= index; i++) {
      translateSeat.push(i);
    }
    translateUnit = -0.5;
  } else {
    for (let i = index; i < newSeats[row].length - 1; i++) {
      translateSeat.push(i);
    }
  }

  newSeats[row].map((item, itemIndex) => {
    if (translateSeat.indexOf(itemIndex) >= 0) {
      item.translate += translateUnit;
    }
  });

  return newSeats;
};

export const addRow = (originalSeats, rowOrder, colOrder, colTitle) => {
  let newSeats = JSON.parse(JSON.stringify(originalSeats));
  let rowLength = newSeats.length;
  let colLength = newSeats[0].length;
  let rowString = "";
  let newRow = [];
  let newColTitle = [ ...colTitle ];
  let lastRowString = "";

  if (rowOrder == "order") {
    rowString = newSeats[rowLength - 2][1].rowString.charCodeAt() + 1;
    lastRowString = rowString + 1;
    rowString = String.fromCharCode(rowString);
    lastRowString = String.fromCharCode(lastRowString);
  } else {
    rowString = "A";
  }

  for (let i = 0; i < colLength; i++) {
    let item = createSeatItem();

    item.sid = rowString + i;

    if (i == 0 || i == colLength - 1) {
      item.seatStatus = null;
      item.whiteBg = true;
    } else {
      item.text = i;
      item.rowString = rowString;
    }

    newRow.push(item);
  }

  if (colOrder != "order") {
    newRow.reverse();
  }

  if (rowOrder == "order") {
    newSeats.splice(rowLength - 1, 0, newRow);
    newColTitle.splice(rowLength - 1, 0, rowString);

    newSeats[newSeats.length - 1].map(item => {
      item.sid = item.sid.replace(rowString, lastRowString);
      return item;
    });
  } else {
    let unShiftRowString = newColTitle[1].charCodeAt() + 1;
    unShiftRowString = String.fromCharCode(unShiftRowString);

    newSeats.map((rowItem, rowIndex) => {
      let thisRowString = "";

      if (rowIndex != newSeats.length - 1) {
        thisRowString = rowItem[1].sid.replace(/[^A-Z]/g, "").charCodeAt() + 1;
        thisRowString = String.fromCharCode(thisRowString);

        rowItem.map(colItem => {
          if (colItem.rowString) {
            colItem.rowString = thisRowString;
          }

          colItem.sid = colItem.sid.replace(/[A-Z]/g, thisRowString);

          if (colItem.link != "") {
            colItem.link += 1;
          }
        });
      }
    });

    newSeats.splice(rowLength - 1, 0, newRow);
    newColTitle.splice(1, 0, unShiftRowString);
  }

  return {
    newSeats,
    newColTitle,
  };
};

export const createForm = () => {
  return {
    name: "",
    housePhotoUrl: "",
    description: "",
    screenCode: "",
    congestionLevels: [
      {
        title: locale("theatre.seat.leager.vacant"),
        colorCode: "#6DF728",
        message: "◯ " + locale("theatre.seat.leager.vacant"),
        occupancy: 0,
        purchasable: true,
      },
      {
        title: locale("theatre.seat.leager.ranout"),
        colorCode: "#FF8C00",
        message: "△ " + locale("theatre.seat.leager.ranout"),
        occupancy: 0,
        purchasable: true,
      },
      {
        title: locale("theatre.seat.leager.filled"),
        colorCode: "#F94646",
        message: "✕ " + locale("theatre.seat.leager.filled"),
        occupancy: 0,
        purchasable: true,
      },
      {
        title: locale("theatre.seat.leager.notforsale"),
        colorCode: "#9E9E9E",
        message: "- " + locale("theatre.seat.leager.notforsale"),
        occupancy: 0,
        purchasable: true,
      }
    ],
    seatingPlan: {
      columnSpacing: 0,
      lineSpacing: 0,
      seatDecorator: createSeatSetting(),
      seats: [],
    },
  };
};

export const createSeatingLevelBtns = () => {
  return [
    {
      text: locale("theatre.seat.general"),
      type: "general",
      color: "#F6E8A4"
    },
    {
      text: locale("theatre.seat.vip"),
      type: "vip",
      color: "#E08F08",
    },
    {
      text: locale("theatre.seat.special"),
      type: "special",
      color: "#A7C6FF",
    },
    {
      text: locale("theatre.seat.stopsale"),
      type: "close",
      color: "#898989",
    },
    {
      text: locale("theatre.seat.windowSeat"),
      type: "posCounter",
      color: "#a65bbd",
    }
  ];
};

export const deleteSeatRow = (index, seats) => {
  const newSeatLength = seats.length - 1;
  let newSeat = JSON.parse(JSON.stringify(seats));
  let colTitle = [];
  let sort = "asc";// desc

  sort = seats[1][1].sid.replace(/[^A-Z]/g, "").charCodeAt() > seats[2][1].sid.replace(/[^A-Z]/g, "").charCodeAt() ? "desc" : "asc";

  newSeat.splice(index, 1);

  for (let i = 0; i < newSeatLength; i++) {
    colTitle.push(String.fromCharCode(64 + i));
  }

  if (sort == "desc") {
    colTitle.reverse();
  }

  newSeat.map((item, itemIndex) => {
    let titleText = colTitle[itemIndex];

    item.map(secItem => {
      secItem.sid = secItem.sid.replace(/[^0-9]/g, titleText);

      if (secItem.rowString != "") {
        secItem.rowString = titleText;
      }
    });
  });

  colTitle[0] = "";
  colTitle[colTitle.length - 1] = "";

  return { newSeat, colTitle };
};
